<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-row justify-space-between">
      <div>
        <h3>Aggregator Update</h3>
        <p>Update detail informasi aggregator</p>
      </div>
    </div>

    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>
    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <div :style="{ padding: '20px 30px 20px 30px' }" v-if="!loading">
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Nomor Rekening BNI</v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="noRekening"
              ref="noRekening"
              v-model="noRekening"
              @change="$v.noRekening.$touch()"
              @blur="$v.noRekening.$touch()"
              :error-messages="noRekeningErrors"
              :loading="isloadingRekening"
            />
          </v-col>
        </v-row>
        <v-row
          style="align-items: center"
          v-show="qrType == '4' || qrType == '5'"
        >
          <v-col cols="10" sm="4" />
          <v-col cols="2" sm="1" />
          <v-col cols="12" sm="7">
            <v-radio-group class="ma-0" v-model="submerchantNotif" column>
              <template v-slot:label>
                <div>
                  Apakah anda membutuhkan <strong>notif transaksi</strong> via
                  API untuk merchant sticker anda?
                </div>
              </template>
              <v-radio label="Ya" value="1" />
              <v-radio label="Tidak" value="0" />
            </v-radio-group>
          </v-col>
        </v-row>
      </div>
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Data PIC</h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 30px 20px 30px' }" v-if="!loading">
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Nama PIC </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              v-model="PICName"
              id="PICName"
              ref="PICName"
              @change="$v.PICName.$touch()"
              @blur="$v.PICName.$touch()"
              :error-messages="PICNameErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Nomor KTP PIC </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="noKTPPIC"
              ref="noKTPPIC"
              v-model="noKTPPIC"
              :counter="16"
              @change="$v.noKTPPIC.$touch()"
              @blur="$v.noKTPPIC.$touch()"
              :error-messages="noKTPPICErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Jabatan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="jabatan"
              ref="jabatan"
              v-model="jabatan"
              @change="$v.jabatan.$touch()"
              @blur="$v.jabatan.$touch()"
              :error-messages="jabatanErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> No Handphone </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="noHandphone"
              ref="noHandphone"
              v-model="noHandphone"
              @change="$v.noHandphone.$touch()"
              @blur="$v.noHandphone.$touch()"
              :error-messages="noHandphoneErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Email </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="emailPIC"
              ref="emailPIC"
              v-model="emailPIC"
              @change="$v.emailPIC.$touch()"
              @blur="$v.emailPIC.$touch()"
              :error-messages="emailPICErrors"
            />
          </v-col>
        </v-row>
      </div>
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">Data Aggregator</h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 30px 20px 30px' }" v-if="!loading">
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Nama Perusahaan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="companyName"
              ref="companyName"
              v-model="companyName"
              @change="$v.companyName.$touch()"
              @blur="$v.companyName.$touch()"
              :error-messages="companyNameErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Nama Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="aggregatorOwnerName"
              ref="aggregatorOwnerName"
              v-model="aggregatorOwnerName"
              @change="$v.aggregatorOwnerName.$touch()"
              @blur="$v.aggregatorOwnerName.$touch()"
              :error-messages="aggregatorOwnerNameErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Nomor KTP Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="noKTP"
              ref="noKTP"
              v-model="noKTP"
              :counter="16"
              @change="$v.noKTP.$touch()"
              @blur="$v.noKTP.$touch()"
              :error-messages="noKTPErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4">
            Nomor NPWP
            {{
              accountType == 'Corporate' ? 'Perusahaan' : 'Pemilik Usaha'
            }}</v-col
          >
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="noNPWP"
              ref="noNPWP"
              hint="NPWP harus 16 digit, mohon lakukan update data NPWP terbaru!"
              persistent-hint
              v-model="noNPWP"
              :counter="16"
              @change="$v.noNPWP.$touch()"
              @blur="$v.noNPWP.$touch()"
              :error-messages="noNPWPErrors"
              class="hint-yellow"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> No Telepon </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              id="areaCode"
              ref="areaCode"
              label="Area Code"
              clearable
              v-model="areaCode"
              :items="itemsAreaCode"
              item-text="kode_area"
              item-value="kode_area"
              :loading="isLoadingAreaCode"
              :search-input.sync="searchAreaCode"
              hide-selected
            >
              <template v-slot:item="data">
                <template v-if="typeof data.item != 'object'">
                  <v-list-item-content>{{ data.item }}</v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      data.item.kode_area
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      data.item.wilayah
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              id="noTelpAggregator"
              ref="noTelpAggregator"
              @change="$v.noTelpAggregator.$touch()"
              @blur="$v.noTelpAggregator.$touch()"
              :error-messages="noTelpAggregatorErrors"
              v-model="noTelpAggregator"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Email </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="email"
              ref="email"
              v-model="email"
              @change="$v.email.$touch()"
              @blur="$v.email.$touch()"
              :error-messages="emailErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Alamat Perusahaan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-textarea
              id="alamatAggregator"
              ref="alamatAggregator"
              rows="2"
              background-color="grey lighten-5"
              auto-grow
              v-model="alamatAggregator"
              @change="$v.alamatAggregator.$touch()"
              @blur="$v.alamatAggregator.$touch()"
              :error-messages="alamatAggregatorErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> Kota, Kecamatan, Kode Pos </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-autocomplete
              id="kodepos"
              ref="kodepos"
              clearable
              v-model="kodepos"
              :items="itemsKodepos"
              :error-messages="kodeposErrors"
              @change="$v.kodepos.$touch()"
              @blur="
                () => {
                  $v.kodepos.$touch();
                  checkKodepos();
                }
              "
              :loading="isLoadingKodepos"
              :search-input.sync="searchKodepos"
              hide-selected
            />
          </v-col>
        </v-row>
        <RegionalMappingFields
          :bcko.sync="bcko"
          :cmer.sync="cmer"
          :referralCode.sync="rmReferalCode"
          :itemsBcko="itemsBcko"
          :searchBcko.sync="searchBcko"
          :loadingBcko="isLoadingBcko"
          :itemsCmer="itemsCmer"
          :searchCmer.sync="searchCmer"
          :loadingCmer="isLoadingCmer"
          :bckoErrors="bckoErrors"
          :cmerErrors="cmerErrors"
          :referralCodeErrors="rmReferalCodeErrors"
          :disableReferral="true"
          @touch-referral="$v.rmReferalCode.$touch()"
          @focus-bcko="onFocusBcko"
          @focus-cmer="onFocusCmer"
        />
      </div>

      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">Endpoint</h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 30px 20px 30px' }" v-if="!loading">
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> URL </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="endpoint"
              ref="endpoint"
              v-model="endpoint"
              @change="$v.endpoint.$touch()"
              @blur="$v.endpoint.$touch()"
              :error-messages="endpointErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> IP Address </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              id="ipAddress"
              ref="ipAddress"
              v-model="ipAddress"
              @change="$v.ipAddress.$touch()"
              @blur="$v.ipAddress.$touch()"
              :error-messages="ipAddressErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> ID Approver 1 </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-autocomplete
              id="IDApprover1"
              ref="IDApprover1"
              clearable
              v-model="IDApprover1"
              :items="itemsApprovalId1"
              item-id="id"
              item-text="username"
              return-object
              @change="$v.IDApprover1.$touch()"
              @blur="$v.IDApprover1.$touch()"
              @focus="onFocusApprover1"
              :error-messages="IDApprover1Errors"
              :loading="isLoadingApprovalId1"
              :search-input.sync="searchApprovalId1"
              hide-selected
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="10" sm="4"> ID Approver 2 </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-autocomplete
              id="IDApprover2"
              ref="IDApprover2"
              clearable
              v-model="IDApprover2"
              :items="itemsApprovalId2"
              item-id="id"
              item-text="username"
              return-object
              @change="$v.IDApprover2.$touch()"
              @blur="$v.IDApprover2.$touch()"
              @focus="onFocusApprover2"
              :error-messages="IDApprover2Errors"
              :loading="isLoadingApprovalId2"
              :search-input.sync="searchApprovalId2"
              hide-selected
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-space-between">
              <v-btn
                small
                color="orange"
                :disabled="saveLoading"
                :style="{ margin: '2px', color: 'white' }"
                @click="back"
              >
                <v-icon dark left> mdi-arrow-left </v-icon>
                Back
              </v-btn>
              <v-btn
                small
                color="blue"
                :disabled="saveLoading"
                :loading="saveLoading"
                :style="{ margin: '2px', color: 'white' }"
                @click="save"
              >
                save
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  numeric,
  maxLength,
  minLength,
  ipAddress,
  url,
} from 'vuelidate/lib/validators';

import {
  dataListIdApprover,
  scrollOptions,
  dataUserRoles,
  dataDelayServiceHit,
} from '../../../store/params';

import {
  isEmpty,
  date,
  regexAlphanumChar,
  regexDoesNotContainPipe,
} from '../../../lib/helpers';
import RegionalMappingFields from '@/components/inputer/RegionalMappingFields.vue';
import regionalMappingMixin from '@/components/inputer/aggregator/mixin';
import regionalMappingValidationMixin from '@/components/inputer/aggregator/validation';

export default {
  components: {
    RegionalMappingFields,
  },
  mixins: [validationMixin, regionalMappingMixin, regionalMappingValidationMixin],
  validations: {
    ...regionalMappingValidationMixin.validations,
    noRekening: {
      required,
      numeric,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.account_number == null ||
            this.errorValidation.account_number.length < 1)
        );
      },
      isRekVc() {
        return (
          this.noRekening.length == 9 ||
          this.noRekening.length == 10 ||
          this.noRekening.length == 16
        );
      },
    },
    PICName: { required, alphanumChar: regexAlphanumChar },
    noKTPPIC: {
      required,
      numeric,
      maxLength: maxLength(16),
      minLength: minLength(16),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.aggre_pic_ktp_no == null ||
            this.errorValidation.aggre_pic_ktp_no.length < 1)
        );
      },
    },
    jabatan: { required, alphanumChar: regexAlphanumChar },
    noHandphone: { required, numeric },
    emailPIC: {
      required,
      email,
      doesNotContainPipe: regexDoesNotContainPipe,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.aggre_pic_email == null ||
            this.errorValidation.aggre_pic_email.length < 1)
        );
      },
    },
    companyName: {
      required() {
        if (this.isCorporate) {
          return this.companyName != '';
        }
        return true;
      },
      alphanumChar: regexAlphanumChar,
    },
    noRekeningPerusahaan: { numeric },
    aggregatorOwnerName: { required, alphanumChar: regexAlphanumChar },
    noKTP: {
      required,
      numeric,
      maxLength: maxLength(16),
      minLength: minLength(16),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.ktp_no == null ||
            this.errorValidation.ktp_no.length < 1)
        );
      },
    },
    noNPWP: {
      required,
      numeric,
      maxLength: maxLength(16),
      minLength: minLength(16),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.npwp_no == null ||
            this.errorValidation.npwp_no.length < 1)
        );
      },
    },
    noTelpAggregator: { numeric },
    email: {
      required,
      email,
      doesNotContainPipe: regexDoesNotContainPipe,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.email == null ||
            this.errorValidation.email.length < 1)
        );
      },
    },
    alamatAggregator: { required, doesNotContainPipe: regexDoesNotContainPipe },
    kodepos: { required },
    endpoint: { url },
    ipAddress: { ipAddress },
    IDApprover1: {
      required() {
        return !isEmpty(this.IDApprover1.id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_1 == null ||
            this.errorValidation.approver_1.length < 1)
        );
      },
    },
    IDApprover2: {
      required() {
        return !isEmpty(this.IDApprover2.id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_2 == null ||
            this.errorValidation.approver_2.length < 1)
        );
      },
    },
  },
  mounted() {
    this.$store.commit('master/daerah/list/clearApprovalId');
    
    this.getDetailData();
    this.getAreaCode();
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      listIDApprover: dataListIdApprover,
      listUserRoles: dataUserRoles,
      isLoadingAreaCode: false,
      isLoadingKodepos: false,
      isLoadingApprovalId1: false,
      isLoadingApprovalId2: false,
      searchApprovalId1: '',
      searchApprovalId2: '',
      approver1Loaded: false,
      approver2Loaded: false,
      searchAreaCode: '',
      searchKodepos: '',
      tempUniqueData: {
        account_number: '',
        aggre_pic_ktp_no: '',
        aggre_pic_email: '',
        npwp_no: '',
        ktp_no: '',
        email: '',
      },
      delayHitServiceA1: null,
      delayHitServiceA2: null,
      isloadingRekening: false,
      isPageUpdate: true,
    };
  },
  watch: {
    noRekening: {
      handler(val) {
        this.getValidateRek(val);

        if (this.errorValidation != null) {
          if (
            this.errorValidation.account_number != null &&
            val != this.errorValidation.account_number
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'account_number'
            );
          }
        }
      },
    },
    noKTPPIC: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.aggre_pic_ktp_no != null &&
            val != this.errorValidation.aggre_pic_ktp_no
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'aggre_pic_ktp_no'
            );
          }
        }
      },
    },
    emailPIC: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.aggre_pic_email != null &&
            val != this.errorValidation.aggre_pic_email
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'aggre_pic_email'
            );
          }
        }
      },
    },
    email: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.email != null &&
            val != this.errorValidation.email
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'email'
            );
          }
        }
      },
    },
    noKTP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.ktp_no != null &&
            val != this.errorValidation.ktp_no
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'ktp_no'
            );
          }
        }
      },
    },
    noNPWP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.npwp_no != null &&
            val != this.errorValidation.npwp_no
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'npwp_no'
            );
          }
        }
        if (val.length === 15 && !val.startsWith('0')) {
          this.noNPWP = `0${val}`;
        }
      },
      immediate: true,
    },
    searchKodepos: {
      handler(val) {
        if (val != null) {
          this.getDaerah();
        }
      },
    },
    searchApprovalId1: {
      handler(val) {
        if (!this.approver1Loaded) return;
        clearTimeout(this.delayHitServiceA1);
        this.delayHitServiceA1 = setTimeout(() => {
          this.getApprovalId1(this.listUserRoles[0].value, val);
        }, dataDelayServiceHit);
      },
    },
    searchApprovalId2: {
      handler(val) {
        if (!this.approver2Loaded) return;
        clearTimeout(this.delayHitServiceA2);
        this.delayHitServiceA2 = setTimeout(() => {
          this.getApprovalId2(this.listUserRoles[1].value, val);
        }, dataDelayServiceHit);
      },
    },
    IDApprover1: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_1?.length > 0) {
          this.$store.commit(
            'inputer/aggregator/clearErrorVariable',
            'approver_1'
          );
        }
      },
      deep: true,
    },
    IDApprover2: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_2?.length > 0) {
          this.$store.commit(
            'inputer/aggregator/clearErrorVariable',
            'approver_2'
          );
        }
      },
      deep: true,
    },
  },
  computed: {
    errorValidation() {
      return this.$store.state.inputer.aggregator.errors;
    },
    /**
     * Whether the last submission was rejected because of specific fields.
     *
     * Only a field-level rejection warrants scrolling to an input. A denied
     * permission, an expired session or a server fault leaves every field
     * valid, so scrolling would send the user hunting for an error that is not
     * there.
     *
     * @returns {boolean} True when at least one field carries an error.
     */
    hasFieldErrors() {
      const errors = this.errorValidation;
      if (errors == null || typeof errors !== 'object') return false;

      return Object.keys(errors).some(
        (field) => (errors[field] || []).length > 0
      );
    },
    data() {
      return this.$store.state.inputer.aggregator.aggregator;
    },
    accountType() {
      return this.data != null ? this.data.account_type : null;
    },
    itemsAreaCode() {
      return this.$store.state.master.daerah.list.areaCode;
    },
    itemsKodepos() {
      return this.$store.state.master.daerah.list.kodepos;
    },
    itemsApprovalId1() {
      const storeList = this.$store.state.master.daerah.list.approvalId1;
      
      if (storeList.length === 0 && this.data && this.data.approver_1_id) {
        return [{
          id: this.data.approver_1_id,
          username: this.data.approver_1,
          user_id: this.data.approver_1_id,
        }];
      }
      
      const list = storeList.find(
        (a) =>
          a.user_id ==
          JSON.parse(localStorage.getItem('logged_in_qram')).user.id
      );
      return list != undefined
        ? [list]
        : storeList;
    },
    itemsApprovalId2() {
      const storeList = this.$store.state.master.daerah.list.approvalId2;
      
      if (storeList.length === 0 && this.data && this.data.approver_2_id) {
        return [{
          id: this.data.approver_2_id,
          username: this.data.approver_2,
          user_id: this.data.approver_2_id,
        }];
      }
      
      return storeList;
    },
    aggregatorPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    noRekening: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'account_number',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.account_number;
      },
    },
    qrType: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'id_qr_type',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.id_qr_type;
      },
    },
    submerchantNotif: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'notif_sticker_status',
          payload: val,
        });
      },
      get() {
        try {
          return this.data == null
            ? ''
            : this.data.notif_sticker_status.toString();
        } catch {
          return '';
        }
      },
    },
    PICName: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'aggre_pic_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.aggre_pic_name;
      },
    },
    noKTPPIC: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'aggre_pic_ktp_no',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.aggre_pic_ktp_no;
      },
    },
    jabatan: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'aggre_pic_jabatan',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.aggre_pic_jabatan;
      },
    },
    noHandphone: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'aggre_pic_mobile_phone',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.aggre_pic_mobile_phone;
      },
    },
    emailPIC: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'aggre_pic_email',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.aggre_pic_email;
      },
    },
    companyName: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'company_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.company_name;
      },
    },
    aggregatorOwnerName: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'owner_name',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.owner_name;
      },
    },
    noRekeningPerusahaan: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'account_number',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.account_number;
      },
    },
    noKTP: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'ktp_no',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.ktp_no;
      },
    },
    noNPWP: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'npwp_no',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.npwp_no;
      },
    },
    email: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'email',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.email;
      },
    },
    areaCode: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'phone_area_code',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.phone_area_code;
      },
    },
    noTelpAggregator: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'phone',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.phone;
      },
    },
    alamatAggregator: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'address',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.address;
      },
    },
    kodepos: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'kode_pos',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.kode_pos;
      },
    },
    endpoint: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'endpoint',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.endpoint;
      },
    },
    ipAddress: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'ip_address',
          payload: val,
        });
      },
      get() {
        return this.data == null ? '' : this.data.ip_address;
      },
    },
    IDApprover1: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'approver_1_id',
          payload: val == null ? '' : val.user_id,
        });
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'approver_1',
          payload: val == null ? '' : val.username,
        });
      },
      get() {
        if (this.data != null && this.data.approver_1_id) {
          return {
            id: this.data.approver_1_id,
            username: this.data.approver_1,
          };
        }
        return '';
      },
    },
    IDApprover2: {
      set(val) {
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'approver_2_id',
          payload: val == null ? '' : val.user_id,
        });
        this.$store.commit('inputer/aggregator/setAggregatorVariable', {
          variable: 'approver_2',
          payload: val == null ? '' : val.username,
        });
      },
      get() {
        if (this.data != null && this.data.approver_2_id) {
          return {
            id: this.data.approver_2_id,
            username: this.data.approver_2,
          };
        }
        return '';
      },
    },
    noRekeningErrors() {
      const errors = [];
      if (!this.$v.noRekening.$dirty) return errors;
      if (!this.$v.noRekening.required) errors.push('No Rekening is required');
      if (!this.$v.noRekening.numeric) errors.push('Must be numeric');
      if (!this.$v.noRekening.isRekVc) errors.push('Must be 9-10 or 16 digits');
      if (!this.$v.noRekening.isUnique) {
        if (this.errorValidation.account_number != null) {
          this.errorValidation.account_number.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    PICNameErrors() {
      const errors = [];
      if (!this.$v.PICName.$dirty) return errors;
      if (!this.$v.PICName.required) errors.push('Nama PIC is required');
      if (!this.$v.PICName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);

      return errors;
    },
    noKTPPICErrors() {
      const errors = [];
      if (!this.$v.noKTPPIC.$dirty) return errors;
      if (!this.$v.noKTPPIC.required) errors.push('KTP number is required');
      if (!this.$v.noKTPPIC.numeric) errors.push('Must be numeric');
      if (!this.$v.noKTPPIC.maxLength)
        errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTPPIC.minLength)
        errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTPPIC.isUnique) {
        if (this.errorValidation.aggre_pic_ktp_no != null) {
          this.errorValidation.aggre_pic_ktp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    jabatanErrors() {
      const errors = [];
      if (!this.$v.jabatan.$dirty) return errors;
      if (!this.$v.jabatan.required) errors.push('Jabatan is required');
      if (!this.$v.jabatan.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },
    emailPICErrors() {
      const errors = [];
      if (!this.$v.emailPIC.$dirty) return errors;
      if (!this.$v.emailPIC.email || !this.$v.emailPIC.doesNotContainPipe)
        errors.push('Must be valid e-mail');
      if (!this.$v.emailPIC.required) errors.push('PIC Email is required');
      if (!this.$v.emailPIC.isUnique) {
        if (this.errorValidation.aggre_pic_email != null) {
          this.errorValidation.aggre_pic_email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },

    noHandphoneErrors() {
      const errors = [];
      if (!this.$v.noHandphone.$dirty) return errors;
      if (!this.$v.noHandphone.required)
        errors.push('No Handphone is required');
      if (!this.$v.noHandphone.numeric) errors.push('Must be numeric');
      return errors;
    },
    companyNameErrors() {
      const errors = [];
      if (!this.$v.companyName.$dirty) return errors;
      if (!this.$v.companyName.required)
        errors.push('Nama Perusahaan is required');
      if (!this.$v.companyName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },

    aggregatorOwnerNameErrors() {
      const errors = [];
      if (!this.$v.aggregatorOwnerName.$dirty) return errors;
      if (!this.$v.aggregatorOwnerName.required)
        errors.push('Nama Pemilik Usaha is required');
      if (!this.$v.aggregatorOwnerName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },
    noRekeningPerusahaanErrors() {
      const errors = [];
      if (!this.$v.noRekeningPerusahaan.$dirty) return errors;
      if (!this.$v.noRekeningPerusahaan.required)
        errors.push('Nomor Rekening Perusahaan is required');
      if (!this.$v.noRekeningPerusahaan.numeric) errors.push('Must be numeric');
      return errors;
    },
    noTelpAggregatorErrors() {
      const errors = [];
      if (!this.$v.noTelpAggregator.$dirty) return errors;
      if (!this.$v.noTelpAggregator.numeric) errors.push('Must be numeric');
      return errors;
    },
    noKTPErrors() {
      const errors = [];
      if (!this.$v.noKTP.$dirty) return errors;
      if (!this.$v.noKTP.required) errors.push('KTP number is required');
      if (!this.$v.noKTP.numeric) errors.push('Must be numeric');
      if (!this.$v.noKTP.maxLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.minLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.isUnique) {
        if (this.errorValidation.ktp_no != null) {
          this.errorValidation.ktp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noNPWPErrors() {
      const errors = [];
      if (!this.$v.noNPWP.$dirty) return errors;
      if (!this.$v.noNPWP.required) errors.push('NPWP number is required');
      if (!this.$v.noNPWP.numeric) errors.push('Must be numeric');
      if (!this.$v.noNPWP.maxLength)
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      if (!this.$v.noNPWP.minLength)
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      if (!this.$v.noNPWP.isUnique) {
        if (this.errorValidation.npwp_no != null) {
          this.errorValidation.npwp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email || !this.$v.email.doesNotContainPipe)
        errors.push('Must be valid e-mail');
      if (!this.$v.email.required) errors.push('Email is required');
      if (!this.$v.email.isUnique) {
        if (this.errorValidation.email != null) {
          this.errorValidation.email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    endpointErrors() {
      const errors = [];
      if (!this.$v.endpoint.$dirty) return errors;
      if (!this.$v.endpoint.url) errors.push('URL not valid');
      return errors;
    },
    ipAddressErrors() {
      const errors = [];
      if (!this.$v.ipAddress.$dirty) return errors;
      if (!this.$v.ipAddress.ipAddress)
        errors.push('Must be a valid IP Address');
      return errors;
    },
    IDApprover1Errors() {
      const errors = [];
      if (!this.$v.IDApprover1.$dirty) return errors;
      if (!this.$v.IDApprover1.required)
        errors.push('ID Approver 1 is required');
      if (!this.$v.IDApprover1.isUnique) {
        if (this.errorValidation.approver_1 != null) {
          this.errorValidation.approver_1.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    IDApprover2Errors() {
      const errors = [];
      if (!this.$v.IDApprover2.$dirty) return errors;
      if (!this.$v.IDApprover2.required)
        errors.push('ID Approver 2 is required');
      if (!this.$v.IDApprover2.isUnique) {
        if (this.errorValidation.approver_2 != null) {
          this.errorValidation.approver_2.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },

    alamatAggregatorErrors() {
      const errors = [];
      if (!this.$v.alamatAggregator.$dirty) return errors;
      if (!this.$v.alamatAggregator.required)
        errors.push('Alamat Aggregator is required');
      if (!this.$v.alamatAggregator.doesNotContainPipe)
        errors.push(`Character is not allowed`);
      return errors;
    },
    kodeposErrors() {
      const errors = [];
      if (!this.$v.kodepos.$dirty) return errors;
      if (!this.$v.kodepos.required)
        errors.push('Kota, Kecamatan, Kode Pos is required');
      return errors;
    },
    namaKodepos() {
      return this.getNamaDaerah('kodepos');
    },
  },
  methods: {
    async getValidateRek(val) {
      this.isloadingRekening = true;
      this.$store
        .dispatch('inputer/aggregator/validate', {
          date,
          no_rekening: val,
        })
        .then(() => {
          this.isloadingRekening = false;
        });
    },
    getNamaDaerah(category) {
      if (this.kodepos != null) {
        let nama = '';
        const splitDaerah = this.kodepos.split(', ');

        const [kelurahan, kecamatan, kabupaten, provinsi, kodepos] =
          splitDaerah;

        switch (category) {
          case 'kodepos':
            nama = kodepos;
            break;
          case 'provinsi':
            nama = provinsi;
            break;
          case 'kabupaten':
            nama = kabupaten;
            break;
          case 'kecamatan':
            nama = kecamatan;
            break;
          case 'kelurahan':
            nama = kelurahan;
            break;
          default:
            break;
        }
        return nama;
      }
      return '';
    },

    async getDaerah() {
      this.isLoadingKodepos = true;
      await this.$store
        .dispatch('master/daerah/list/getDaerah', {
          query: this.searchKodepos == null ? '' : this.searchKodepos,
        })
        .finally(() => {
          this.isLoadingKodepos = false;
        });
    },

    async getAreaCode() {
      this.isLoadingAreaCode = true;
      await this.$store
        .dispatch('master/daerah/list/getAreaCode', {
          date,
          query: this.searchAreaCode,
        })
        .finally(() => {
          this.isLoadingAreaCode = false;
        });
    },

    async getApprovalId1(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId1 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId1', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId1.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId1 = '';
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId1 = false;
        });
    },

    async getApprovalId2(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId2 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId2', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId2.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId2 = '';
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId2 = false;
        });
    },

    onFocusApprover1() {
      if (!this.approver1Loaded) {
        this.approver1Loaded = true;
        this.getApprovalId1(this.listUserRoles[0].value, '', false);
      }
    },

    onFocusApprover2() {
      if (!this.approver2Loaded) {
        this.approver2Loaded = true;
        this.getApprovalId2(this.listUserRoles[1].value, '', false);
      }
    },

    async getDetailData() {
      this.loading = true;
      await this.$store
        .dispatch('inputer/aggregator/viewAggregator', {
          id: this.$route.params.id,
          date,
          isPageUpdate: this.isPageUpdate
        })
        .then(() => {
          const kodeposLengkap = `${this.data.kelurahan}, ${this.data.kecamatan}, ${this.data.kabupaten_kota}, ${this.data.provinsi}, ${this.data.kode_pos}`;
          this.searchKodepos = kodeposLengkap;
          this.kodepos = kodeposLengkap;
          this.setRegionalMappingFromDetail();
          this.tempUniqueData = {
            account_number: this.noRekening,
            aggre_pic_ktp_no: this.noKTPPIC,
            aggre_pic_email: this.emailPIC,
            npwp_no: this.noNPWP,
            ktp_no: this.noKTP,
            email: this.email,
          };
        })
        .catch(() => {
          this.$router.back();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveLoading = true;
        const daerah = {
          province_name: this.getNamaDaerah('provinsi'),
          city_name: this.getNamaDaerah('kabupaten'),
          sub_district_name: this.getNamaDaerah('kecamatan'),
          urban_name: this.getNamaDaerah('kelurahan'),
          postal_code: this.getNamaDaerah('kodepos'),
        };
        await this.$store
          .dispatch('inputer/aggregator/updateAggregator', {
            date,
            daerah,
            aggregator_id: this.$route.params.id,
            tempUniqueData: this.tempUniqueData,
            regionalMapping: {
              bcko: this.bcko?.id || this.bcko?.branch_code_bcko || '',
              cmer: this.cmer?.id || this.cmer?.code || '',
              referral_code: this.rmReferalCode || '',
            },
          })
          .then((response) => {
            if (response) {
              this.$router.push('/inputer/aggregator');
            } else if (this.hasFieldErrors) {
              this.scrollToErrorInput();
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.scrollToErrorInput();
      }
    },

    checkKodepos() {
      this.searchKodepos = this.kodepos;
    },

    scrollToErrorInput() {
      const keys = Object.keys(this.$v);
      let isError = false;

      keys.forEach((key) => {
        const input = key;

        if (input.includes('$')) return;

        if (this.$v[input].$error) {
          this.$vuetify.goTo(`#${input}`, scrollOptions);
          isError = true;
        }
      });

      if (!isError) this.$vuetify.goTo(0);
    },

    back() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.hint-yellow ::v-deep .theme--light.v-messages {
  color: #ffa014;
}
</style>